import React from 'react';
import PropTypes from 'prop-types';
import { FaAsterisk } from 'react-icons/fa';
// import { InputContainer } from './FormElements.styles';
import { FieldContainer } from './Input.styles';

const ProvinceInput = ({
  title = 'Province',
  value,
  nestedValue,
  upperValue,
  name,
  className = '',
  requiredInput = false,
  containerClassName = '',
  detail = '',
}) => {
  const provinces = [
    'AB', // Alberta
    'BC', // British Columbia
    'MB', // Manitoba
    'NB', // New Brunswick
    'NL', // Newfoundland and Labrador
    'NS', // Nova Scotia
    'NT', // Northwest Territories
    'NU', // Nunavut
    'ON', // Ontario
    'PE', // Prince Edward Island
    'QC', // Quebec
    'SK', // Saskatchewan
    'YT', // Yukon
  ];

  // Handle the change event
  const handleChange = (e) => {
    const selectedProvince = e.target.value;
    nestedValue({
      ...upperValue,
      [name]: selectedProvince,
    });
  };

  return (
    <FieldContainer className={containerClassName}>
      <label className={className}>
        {title}{' '}
        {requiredInput && (
          <FaAsterisk
            size={12}
            color="var(--orange4)"
            style={{ marginLeft: 4 }}
          />
        )}{' '}
        <span className="detail">{detail}</span>
      </label>
      <select name={name} onChange={handleChange} value={value}>
        <option value="">Select Province</option>
        {provinces.map((province) => (
          <option key={province} value={province}>
            {province}
          </option>
        ))}
      </select>
    </FieldContainer>
  );
};

ProvinceInput.propTypes = {
  title: PropTypes.string,
  value: PropTypes.string,
  nestedValue: PropTypes.func,
  upperValue: PropTypes.object,
  name: PropTypes.string,
  className: PropTypes.string,
  requiredInput: PropTypes.bool,
  containerClassName: PropTypes.string,
  detail: PropTypes.string,
};

export default ProvinceInput;
